import { isResourceDetailFolder } from '../../../utils/resourceDetailGuards.js';
import { useRef, useCallback } from 'react';
import { useDefaultResourceClickHandler } from '@fabric-app/compat';

const useResourceClickHandler = (options) => {
  const refOnClickFolder = useRef(options?.onClickFolder);
  refOnClickFolder.current = options?.onClickFolder;
  const refOnClickResource = useRef(options?.onClickResource);
  refOnClickResource.current = options?.onClickResource;
  const { defaultClickFolder, defaultClickResource } = useDefaultResourceClickHandler();
  const handleClick = useCallback((resource) => {
    if (resource.isDraft) {
      return;
    }
    if (isResourceDetailFolder(resource)) {
      if (refOnClickFolder.current) {
        refOnClickFolder.current(resource);
        return;
      } else {
        defaultClickFolder(resource);
        return;
      }
    }
    if (refOnClickResource.current) {
      refOnClickResource.current(resource);
      return;
    } else {
      defaultClickResource(resource);
    }
  }, [
    refOnClickResource,
    refOnClickFolder,
    defaultClickFolder,
    defaultClickResource
  ]);
  return handleClick;
};

export { useResourceClickHandler };
//# sourceMappingURL=useResourceClickHandler.js.map
